import AnimatedPressable from "./animated-pressable";
import { createLinkComponent } from "react-native-ridge-navigation";

const AnimatedLink = createLinkComponent(AnimatedPressable);
export default AnimatedLink;
